export default "__VITE_ASSET__9ea4db36__"